import React from "react"
import "./style.scss"
import Layout from "../../../components/layout/layout"
import tss from "../../../images/tss.svg"
import tWorldwide from "../../../images/tWorldwide.svg"
import drivex from "../../../images/drivex.svg"
import bannerImage from "./banner.svg"
import ServiceHeader from "../../../components/serviceCards/serviceHeader"
import OverviewSection from "../../../components/serviceCards/overviewSection"
import ServicesSection from "../../../components/serviceCards/servicesSection"
import PointsSection from "../../../components/serviceCards/pointsSection"
import BookingSection from "../../../components/serviceCards/bookingSection"
import CustomerSection from "../../../components/serviceCards/customerSection"
import RelatedArticles from "../../../components/cards/relatedarticles/RelatedArticles"
import { graphql } from "gatsby"
import SEO from "../../../components/seo"

const WebScraping = ({ data, location: { pathname } }) => {
  const datas = {
    title: "Get the website data available in executable formats.",
    text:
      "Break down thousands of web pages into usable formats with Wersel’s data scraping services.",
    overviewTitle: "What is Web Scraping?",
    overviewText: [
      "Web scraping or data scraping is an efficient process of extracting and breaking down the data available on a website into a readable file format such as a spreadsheet on your computer. And with Wersel’s web scraping services, you can effectively scrap data from any website on the internet. Our data scraping services crawl the web pages very thoroughly and extract the desired data for the client. Whether it be product catalogue, inventory data, statistical data, images, or text content, with our highly proactive web scraping solutions, you can effortlessly extract the required data from any webpage on the go.",
      <br />,
      <br />,
      "At Wersel, we understand that most of the enterprises love data in Excel spreadsheet format, but at the same time, we also know that some businesses need data in other not-so-popular file formats. Therefore, our web scraping services emphasize making data available in various formats to the client. Plus, you don’t need any software to access and use our flexible and highly reliable web scraping services.",
    ],
    serviceSubtitle:
      "Our time conserving scraping services are highly safe, and you can scale them as per your business needs.",
    services: [
      {
        title: "Accurate & Exact Data",
        content:
          "Scraping the data on your can be a real headache. The website may change, or the agents may stop working, or in the worst case, the data might get broken. Well, not if you hire our data extractions services. All you have to do is share your data requirement with us, and we will provide you with the most relevant and accurate data from the given source. ",
      },
      {
        title: "Flexible and Scalable",
        content:
          "It does not matter if your web scraping needs are recurring in nature or a one-time affair; our expert data scientists can flexibly take on any data harvesting project and deliver highly satisfying data extraction results in the given timeframe as per the client's needs.",
      },
      {
        title: "Reduced Manpower Needs for You",
        content:
          "Having hired Wersel’s web scraping services, you won't have to worry about hiring a workforce to look after debugging and manage agents, monitor the updates on targeted sites, upgrade the system specifications; you won't even have to spend extra money on anything else because everything will be taken care of by us.",
      },
      {
        title: "No Redundancy",
        content:
          "It doesn't matter how accurate the extracted data is; it will go in vain if it cannot be delivered to the client at the right time. Therefore, we take full accountability and complete responsibility to deliver the extracted data at the right time.",
      },
    ],
    whyPartnerWerselTitle: "Why Partner with Wersel Workdesk?",
    whyPartnerWerselText:
      "While there are innumerable web scraping service providers, only a handful of them can manage to convert the unstructured data on the web into consumable structured data formats. And Wersel is one of them. With our expertise in versatile data scraping and extraction services, we extract and provide our clients with highly accurate data from- ",
    points: [
      {
        title: "Financial markets and stock markets around the world",
        content: "",
      },
      {
        title:
          "Product catalogues, product price, inventory data, and distribution chain",
        content: "",
      },
      {
        title: "Real estate and housing sector ",
        content: "",
      },
      {
        title: "Human resources and job details",
        content: "",
      },
      {
        title: "Airlines, hotels, and travel companies",
        content: "",
      },
      {
        title: "Deep web and dark web",
        content: "",
      },
      {
        title: "Marketing and sales campaigns",
        content: "",
      },
      {
        title: "Journalism and research projects ",
        content: "",
      },
      {
        title: "Social media platforms",
        content: "",
      },
    ],
    howItWorksTitle: "Need enterprise-grade web scraping services?",
    howItWorks:
      "Utilize our data scraping services and gain efficient means of collecting information that can be vital for your business profitability. Contact us immediately!",
    customers: [
      {
        name: "George",
        description: "Chief Executive Officer (CEO) - TSS",
        commentTitle: "They made My Business",
        comment:
          "We approach Datinfi based on their expirience in handling AI & ML Models, and the team did not dissappoint. They helped me to expand my business with more retailers and also increased 30% in my monthly recurring revenue",
        image: tss,
        id: 1,
      },
      {
        name: "Chris Shargunan",
        description: "Chief Technology Officer (CTO) - DriveX",
        commentTitle: "They made My Business",
        comment:
          "We developed a great rapport eith Datinfi and their dedication to our web portal development is evident in all aspects of the site. We appriciate their attention to detail and creative approach to bringing our new exhibit to life online",
        image: tWorldwide,
        id: 2,
      },
      {
        name: "Veles Nalliah",
        description: "BIIT Consulting",
        commentTitle: "They made My Business",
        comment:
          "Well! Wersel business app with analytics, becoming the core component of our business decision-making process. Datinfi has been a superior company to do the business with",
        image: drivex,
        id: 3,
      },
    ],
  }
  const {
    title,
    text,
    overviewTitle,
    overviewText,
    whyPartnerWerselTitle,
    whyPartnerWerselText,
    services,
    points,
    howItWorks,
    howItWorksTitle,
    customers,
  } = datas
  return (
    <Layout withBrand slidePosition={0}>
      <SEO
        title="Versatile Web Data Scraping And Extraction Services"
        description="Get the website data available in executable formats. Break down thousands of web pages into usable formats with Wersel’s web data scraping services."
        keywords="scraping services, web scraping services usa, web scraping services provider, web data scraping service, web scraping company"
        url="http://www.wersel.io/solutions/web-scraping"
      />
      <div className="services">
        <ServiceHeader title={title} text={text} image={bannerImage} />
        <OverviewSection
          overviewTitle={overviewTitle}
          overviewText={overviewText}
        />
        <ServicesSection services={services} />
        <OverviewSection
          overviewTitle={whyPartnerWerselTitle}
          overviewText={whyPartnerWerselText}
        />
        <PointsSection points={points} />
        <BookingSection
          howItWorksTitle={howItWorksTitle}
          howItWorks={howItWorks}
        />
        {/* <CustomerSection customers={customers} /> */}
        <RelatedArticles
          path={pathname}
          posts={data.posts.edges}
          title="Related Articles"
        />
      </div>
    </Layout>
  )
}
export const pageQuery = graphql`
  query WebScraping {
    posts: allMarkdownRemark {
      edges {
        node {
          id
          frontmatter {
            title
            path
            description
          }
        }
      }
    }
  }
`
export default WebScraping
